export const localStorageHelper = {
  get: (key: string) => {
    const value = localStorage.getItem(key);
    return value ? (JSON.parse(value) as { value: any }) : null;
  },
  set: (key: string, value: any) => {
    localStorage.setItem(key, JSON.stringify({ value }));
  },
};
